import { render, staticRenderFns } from "./DashboardDropDown.vue?vue&type=template&id=c15e3878&scoped=true&"
import script from "./DashboardDropDown.vue?vue&type=script&lang=js&"
export * from "./DashboardDropDown.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDropDown.vue?vue&type=style&index=0&id=c15e3878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15e3878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VDialog,VIcon,VListItem,VListItemTitle,VSkeletonLoader,VSpacer,VSubheader})
